import styled from '@emotion/styled'
import { css } from '@emotion/core'

const arrowTypePositionTop = props => (props.type === 'arrow' && props.position === 'top') &&
  css`
  left: 50%;
  transform: translateX(-50%) translateY(-12px) scale(1);
  bottom: 100%;
  
  &:after {
    transform: translateX(-50%);
    top: 100%;
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #ffffff;
    border-width: 8px;
    margin-right: -8px;
  }
  
  &:before {
    transform: translateX(-50%);
    top: 100%;
    border-color: rgba(230, 232, 232, 0);
    border-top-color: rgba(255, 255, 255, 0.85);
    border-width: 9px;
    margin-right: -9px;
  }
`

const arrowTypePositionBottom = props => (props.type === 'arrow' && props.position === 'bottom') &&
  css`
  &:after {
     border-color: rgba(255, 255, 255, 0);
     border-bottom-color: #ffffff;
     border-width: 8px;
     margin-left: -8px;
   }

  &:before {
    border-color: rgba(230, 232, 232, 0);
    border-bottom-color: #ffffff;
    border-width: 9px;
    margin-left: -9px;
  }
`

const arrowTypePositionBottomRight = props => (props.type === 'arrow' && props.position === 'bottom-right') &&
  css`
  right: 0;

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #ffffff;
    border-width: 8px;
    margin-left: 60px;
  }

  &:before {
    border-color: rgba(230, 232, 232, 0);
    border-bottom-color: #ffffff;
    border-width: 9px;
    margin-left: 61px;
  }
`

const arrowTypePositionBottomLeft = props => (props.type === 'arrow' && props.position === 'bottom-left') &&
  css`
  right: 0;

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #ffffff;
    border-width: 8px;
    margin-left: -68px;
  }

  &:before {
    border-color: rgba(230, 232, 232, 0);
    border-bottom-color: #ffffff;
    border-width: 9px;
    margin-left: -69px;
  }
`

const blockStyling = props => props.type === 'block' &&
  css`
  width: 100%;
  min-width: 0;
  box-shadow: none;
  margin-top: 0;
  
  border-radius: 0 0 6px 6px;
`

const PopoverWrapper = styled.div`
  position: absolute;
  background: #fff;
  border-radius: 6px;
  z-index: 999;
  color: #000;
  min-width: 180px;
  box-shadow: 0 4px 32px 0 rgba(0,0,0,0.25);
  margin-top: 8px;

  &:after {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  ${arrowTypePositionBottom}
  ${arrowTypePositionBottomRight}
  ${arrowTypePositionBottomLeft}
  ${arrowTypePositionTop}
  
  ${blockStyling}
`

export default PopoverWrapper
